import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FaqCategory} from '../../../../model/FaqCategory';
import {FormControl, FormGroup, ReactiveFormsModule, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbNav, NgbNavContent, NgbNavItem, NgbNavLink, NgbNavOutlet, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {UserProductFormComponent} from "../user-product-form/user-product-form.component";
import {UserProductsFormGeneratorService} from "../../../../formulaires/user/user-products-list-form-generator.service";
import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import {Product} from "../../../../model/product";
import { FieldComponent } from 'src/app/components/common/fields/field/field.component';
import { FieldDefinition } from 'src/app/model/field-definition';
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';

@Component({
    selector: 'app-user-products-list-form',
    imports: [
        CommonModule,
        FaIconComponent,
        ReactiveFormsModule,
        NgbNav,
        NgbNavItem,
        UserProductFormComponent,
        NgbNavOutlet,
        NgbNavLink,
        NgbTooltip,
        NgbNavContent,
        DynamicFormComponent,
        FieldComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './user-products-list-form.component.html',
    styleUrls: ['./user-products-list-form.component.css']
})
export class UserProductsListFormComponent implements OnInit {
  @Input() parentForm!: UntypedFormGroup;
  @Input() formName: string;
  @Input() products: FaqCategory[];
  @Input() canreplace = true;

  enabledProducts: FaqCategory[] = [];

  form: FormGroup;
  addProductForm;
  tmpForm;
  active = 'choice';
  questions;

  question = new FieldDefinition<string>({
    key: 'tmpproduct',
    label: 'Logiciel concerné',
    type: 'select',
    placeholder: 'Sélectionner le logiciel concerné',
    required: true,
    fullsize: true,
    options: [],
    order: 1
  });

  constructor(private userProductsFormGeneratorService: UserProductsFormGeneratorService,
              private qcs: QuestionControlService) {
  }

  ngOnInit(): void {
    const form = this.parentForm.get(this.formName) as UntypedFormGroup;
    this.loadQuestions(form);
  }

  private loadQuestions(form: UntypedFormGroup) {
    if (form !== null) {
      // Set already defined products
      Object.keys(form.controls).forEach(key => {
        this.addToEnabledProducts(key);
      });
    }
    let options = [];
    if (this.products !== undefined) {
      options = this.products.filter(p => {
        return this.enabledProducts.indexOf(p) === -1;
      }).map(p => {
        return {key: p.slug, value: p.name};
      });
    }
    this.question.options = options;
    this.userProductsFormGeneratorService.getQuestions(options).subscribe(q => {
      this.questions = q;
      if (this.parentForm.contains(this.formName)) {
        this.form = this.parentForm.controls[this.formName] as FormGroup;
      } else {
        this.addProductForm = this.qcs.toFormGroup(this.questions, () => {});
        this.form = new FormGroup({required: new FormControl('', [Validators.required])});
        this.parentForm.setControl(this.formName, this.form);
      }
      this.generateTmpForm();
    });
  }

  generateTmpForm(): void {
    let options = [];
    if (this.products !== undefined) {
      options = this.products.filter(p => {
        return this.enabledProducts.indexOf(p) === -1;
      }).map(p => {
        return {key: p.slug, value: p.name};
      });
    }
    this.question.options = options;
    this.question.value = undefined;
    this.question.required = this.enabledProducts.length === 0;

    if(this.question.required) {
      this.form.addControl("required",  new FormControl('', [Validators.required]));
    } else {
      this.form.removeControl("required");
    }

    this.tmpForm = this.qcs.toFormGroup([this.question], (values) => {
      if(values.tmpproduct && values.tmpproduct !== ''){
        this.addToEnabledProducts(values.tmpproduct);
        this.generateTmpForm();
      }
    });
  }

  addToEnabledProducts(slug: string): void {
    const product = this.products.find(p => p.slug === slug);
    if (this.enabledProducts.indexOf(product) === -1 && product) {
      this.enabledProducts.push(product);
      this.active = product.slug;
    }
  }

  removeProduct(event, product): void {
    this.active = 'choice';
    this.enabledProducts.splice(this.enabledProducts.indexOf(product), 1);
    this.form.removeControl(product.slug);
    this.generateTmpForm();
    event.preventDefault();
    event.stopImmediatePropagation();

  }

  getValidity(p: FaqCategory): string {
    return this.form?.controls[p.slug] ? this.form?.controls[p.slug]?.status : '';
  }
}
